<template>
	<div class="EmpleadosNuevo">
		<h1>Editar empleado</h1>
		<md-layout md-flex="100" md-gutter="24" md-align="center">
			<md-layout md-column md-flex-xsmall="100" md-flex-small="100" md-flex-medium="50" md-flex-large="45" md-flex-xlarge="40">
				<md-card class="m-b-24">
					<md-card-header>
						<div class="md-title">Información general del empleado</div>
						<div class="md-subhead">Los campos marcados con * son obligatorios</div>
					</md-card-header>
					<md-card-content>
						<md-layout md-flex="100" md-gutter="24">
							<md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_nombre }">
									<label>Nombre</label>
									<md-input v-model="empleado.nombre_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_ap_pat }">
									<label>Ap. paterno</label>
									<md-input v-model="empleado.ap_pat_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_ap_mat }">
									<label>Ap. materno</label>
									<md-input v-model="empleado.ap_mat_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_fecha_nac }">
									<label>Formato día/mes/año</label>
									<md-input v-model="empleado.fecha_nac_emn" v-mask="'##/##/####'" placeholder="Fecha de nacimiento" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_sexo }">
									<label for="sexo_emn">Sexo</label>
									<md-select name="sexo_emn" id="sexo_emn" v-model="empleado.sexo_emn" required>
										<md-option value="masculino">Masculino</md-option>
										<md-option value="femenino">Femenino</md-option>
									</md-select>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_estado_civil }">
									<label for="estado_civil_emn">Estado civíl</label>
									<md-select name="estado_civil_emn" id="estado_civil_emn" v-model="empleado.estado_civil_emn">
										<md-option value="soltero">Soltero</md-option>
										<md-option value="casado">Casado</md-option>
										<md-option value="divorciado">Divorciado</md-option>
										<md-option value="unión libre">Unión libre</md-option>
										<md-option value="viudo">Viudo</md-option>
									</md-select>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="70" md-flex-small="80" md-flex-medium="80" md-flex-large="80" md-flex-xlarge="80">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_direccion }">
									<label>Dirección</label>
									<md-input v-model="empleado.direccion_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="30" md-flex-small="20" md-flex-medium="20" md-flex-large="20" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_num_ext }">
									<label># ext.</label>
									<md-input v-model="empleado.num_ext_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="70" md-flex-small="80" md-flex-medium="80" md-flex-large="80" md-flex-xlarge="80">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_colonia }">
									<label>Colonia</label>
									<md-input v-model="empleado.colonia_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="30" md-flex-small="20" md-flex-medium="20" md-flex-large="20" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_codigo_postal }">
									<label>C.P.</label>
									<md-input v-model="empleado.codigo_postal_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_municipio }">
									<label>Municipio</label>
									<md-input v-model="empleado.municipio_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_estado }">
									<label>Estado</label>
									<md-input v-model="empleado.estado_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="33" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_tel }">
									<label>Teléfono</label>
									<md-input v-mask="'(###) ###-####'" v-model="empleado.tel_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="33" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_cel }">
									<label>Celular</label>
									<md-input v-mask="'(###) ###-####'" v-model="empleado.cel_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="33" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_email }">
									<label>Email</label>
									<md-input v-model="empleado.email_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="22">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_escolaridad }">
									<label></label>
									<label for="escolaridad_emn">Escolaridad</label>
									<md-select name="escolaridad_emn" id="escolaridad_emn" v-model="empleado.escolaridad_emn">
										<md-option value="primaria">Primaria</md-option>
										<md-option value="secundaria">Secundaria</md-option>
										<md-option value="preparatoria">Preparatoria</md-option>
										<md-option value="licenciatura">Licenciatura</md-option>
										<md-option value="otro">Otro</md-option>
									</md-select>
								</md-input-container>
							</md-layout>
						</md-layout>
						<md-layout md-flex="100" md-gutter="24">
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_nss }">
									<label>NSS</label>
									<md-input v-model="empleado.nss_emn" maxlength="11"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_curp }">
									<label>CURP</label>
									<md-input v-model="empleado.curp_emn" maxlength="18" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_rfc }">
									<label>RFC</label>
									<md-input v-model="empleado.rfc_emn" maxlength="13"></md-input>
								</md-input-container>
							</md-layout>
						</md-layout>
						<md-layout md-flex="100" md-gutter="24">
							<md-layout md-flex-xsmall="50" md-flex-small="33" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_peso }">
									<label>Peso KGS</label>
									<md-input type="number" min="0" v-model="empleado.peso_emn" placeholder="Peso"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="50" md-flex-small="33" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_estatura }">
									<label>Estatura MTS</label>
									<md-input v-model="empleado.estatura_emn" placeholder="Estatura" type="number" step=".01"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="50" md-flex-small="33" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_camisa }">
									<label>Camisa</label>
									<md-select name="camisa_emn" id="camisa_emn" v-model="empleado.camisa_emn">
										<md-option value="32">32</md-option>
										<md-option value="34">34</md-option>
										<md-option value="36">36</md-option>
										<md-option value="38">38</md-option>
										<md-option value="40">40</md-option>
										<md-option value="42">42</md-option>
										<md-option value="44">44</md-option>
										<md-option value="46">46</md-option>
										<md-option value="48">48</md-option>
									</md-select>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="50" md-flex-small="33" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_pantalon }">
									<label>Pantalón</label>
									<md-select name="pantalon_emn" id="pantalon_emn" v-model="empleado.pantalon_emn">
										<md-option value="28">28</md-option>
										<md-option value="30">30</md-option>
										<md-option value="32">32</md-option>
										<md-option value="34">34</md-option>
										<md-option value="36">36</md-option>
										<md-option value="38">38</md-option>
										<md-option value="40">40</md-option>
										<md-option value="42">42</md-option>
										<md-option value="44">44</md-option>
										<md-option value="46">46</md-option>
										<md-option value="48">48</md-option>
									</md-select>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="50" md-flex-small="33" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_calzado }">
									<label>Calzado</label>
									<md-select name="calzado_emn" id="calzado_emn" v-model="empleado.calzado_emn">
										<md-option value="2">2</md-option>
										<md-option value="2.5">2.5</md-option>
										<md-option value="3">3</md-option>
										<md-option value="3.5">3.5</md-option>
										<md-option value="4">4</md-option>
										<md-option value="4.5">4.5</md-option>
										<md-option value="5">5</md-option>
										<md-option value="5.5">5.5</md-option>
										<md-option value="6">6</md-option>
										<md-option value="6.5">6.5</md-option>
										<md-option value="7">7</md-option>
										<md-option value="7.5">7.5</md-option>
										<md-option value="8">8</md-option>
										<md-option value="8.5">8.5</md-option>
										<md-option value="9">9</md-option>
										<md-option value="9.5">9.5</md-option>
										<md-option value="10">10</md-option>
										<md-option value="10.5">10.5</md-option>
										<md-option value="11">11</md-option>
										<md-option value="11.5">11.5</md-option>
										<md-option value="12">12</md-option>
										<md-option value="12.5">12.5</md-option>
										<md-option value="13">13</md-option>
									</md-select>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="50" md-flex-small="33" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_complexion }">
									<label>Complexión</label>
									<md-input v-model="empleado.complexion_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="50" md-flex-small="33" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_ojos }">
									<label>Ojos</label>
									<md-input v-model="empleado.ojos_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="50" md-flex-small="33" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_piel }">
									<label>Piel</label>
									<md-input v-model="empleado.piel_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="50" md-flex-small="33" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_cabello }">
									<label>Cabello</label>
									<md-input v-model="empleado.cabello_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="50" md-flex-small="33" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="20">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_tipo_sangre }">
									<label>Sangre</label>
									<md-select name="tipo_sangre_emn" id="tipo_sangre_emn" v-model="empleado.tipo_sangre_emn">
										<md-option value="A−">A−</md-option>
										<md-option value="A+">A+</md-option>
										<md-option value="B−">B−</md-option>
										<md-option value="B+">B+</md-option>
										<md-option value="AB−">AB−</md-option>
										<md-option value="AB+">AB+</md-option>
										<md-option value="O-">O-</md-option>
										<md-option value="O+">O+</md-option>
										<md-option value="otro">NO SABE</md-option>
									</md-select>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="75" md-flex-small="75" md-flex-medium="75" md-flex-large="75" md-flex-xlarge="75">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_experiencia }">
									<label>Experiencia</label>
									<md-input v-model="empleado.experiencia_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="25" md-flex-small="25" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_anos_exp }">
									<label>Años experiencia</label>
									<md-input v-model="empleado.anos_exp_emn" placeholder="Años exp."></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="100" md-flex-xlarge="100">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_observaciones }">
									<label>Observaciones</label>
									<md-textarea v-model="empleado.observaciones_emn"></md-textarea>
								</md-input-container>
							</md-layout>
						</md-layout>
					</md-card-content>
					<md-card-actions>
						<router-link tag="md-button" to="/empleados">Cancelar</router-link>
						<md-button class="md-raised md-primary" @click.native="actualizarEmpleado()">Guardar cambios</md-button>
					</md-card-actions>
				</md-card>
			</md-layout>
			<md-layout md-column md-flex-xsmall="100" md-flex-small="100" md-flex-medium="50" md-flex-large="45" md-flex-xlarge="40">
				<md-card>
					<md-card-header>
						<div class="md-title">Información familiar y de contacto</div>
						<div class="md-subhead">Los campos marcados con * son obligatorios</div>
					</md-card-header>
					<md-card-content>
						<md-layout md-flex="100" md-gutter="24">
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_nombre_conyuge }">
									<label>Nombre del cónyuge</label>
									<md-input v-model="empleado.nombre_conyuge_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_tel_conyuge }">
									<label>Teléfono del cónyuge</label>
									<md-input v-mask="'(###) ###-####'" v-model="empleado.tel_conyuge_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_hijos }">
									<label>Hijos</label>
									<md-input type="number" min="0" steps="1" v-model="empleado.hijos_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_dependientes }">
									<label>Dependientes</label>
									<md-input type="number" min="0" steps="1" v-model="empleado.dependientes_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="100" md-flex-xlarge="100">
								<md-button class="md-raised md-accent" @click.native="conyugueCopiarAContacto()">
									Usar información de cónyugue como contacto
								</md-button>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="70" md-flex-medium="70" md-flex-large="70" md-flex-xlarge="70">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_persona_contacto }">
									<label>Persona de contacto</label>
									<md-input v-model="empleado.persona_contacto_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="30" md-flex-medium="30" md-flex-large="30" md-flex-xlarge="30">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_tel_contacto }">
									<label>Tel. contacto</label>
									<md-input v-mask="'(###) ###-####'" v-model="empleado.tel_contacto_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="75" md-flex-small="75" md-flex-medium="75" md-flex-large="75" md-flex-xlarge="75">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_direccion_contacto }">
									<label>Dirección de contacto</label>
									<md-input v-model="empleado.direccion_contacto_emn" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="25" md-flex-small="25" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_num_contacto }">
									<label># ext</label>
									<md-input v-model="empleado.num_contacto_emn"></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-flex-xsmall="100" md-flex-small="75" md-flex-medium="75" md-flex-large="75" md-flex-xlarge="75">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_colonia_contacto }">
									<label>Colonia de contacto</label>
									<md-input v-model="empleado.colonia_contacto_emn"></md-input>
								</md-input-container>
							</md-layout>
						</md-layout>
					</md-card-content>
					<md-card-actions>
						<router-link tag="md-button" to="/empleados">Cancelar</router-link>
						<md-button class="md-raised md-primary" @click.native="actualizarEmpleado()">Guardar cambios</md-button>
					</md-card-actions>
				</md-card>
			</md-layout>
		</md-layout>
	</div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
	name: "EmpleadosNuevo",
	methods: {
		conyugueCopiarAContacto() {
			this.empleado.persona_contacto_emn = this.empleado.nombre_conyuge_emn;
			this.empleado.tel_contacto_emn = this.empleado.tel_conyuge_emn;
		},
		obtenerEmpleado() {
			this.$http
			.post("empleados/editar", {
				token: this.$session.get("token"),
				empleado: this.$route.params.empleado
			})
			.then(
				response => {
					if (response.status === 200 && "empleado" in response.body) {
						this.empleado = response.body.empleado;
					} else {
						Snackbar.show({
							text:
							"No se encontró el empleado que busca. Inténtelo de nuevo.",
							actionText: "Cerrar",
							pos: "top-right",
							showAction: false,
							backgroundColor: "#F44336",
							actionTextColor: "#FFF"
						});
						this.$router.push("/empleados");
					}
				},
				response => {
					Snackbar.show({
						text: "No se pudo establecer conexión con el servidor.",
						actionText: "Cerrar",
						pos: "top-right",
						showAction: false,
						backgroundColor: "#F44336",
						actionTextColor: "#FFF"
					});
					this.$router.push("/empleados");
				}
				);
		},
		actualizarEmpleado() {
			if (this.validarEmpleado()) {
				var formData = new FormData();
				formData.append("token", this.$session.get("token"));
				formData.append("empleado", JSON.stringify(this.empleado));
				formData.append("data", this.$route.params.empleado);
				this.$http.post("empleados/actualizar", formData).then(
					response => {
						if (response.status === 200 && "msg" in response.body) {
							Snackbar.show({
								text: response.body.msg,
								actionText: "Cerrar",
								pos: "top-right",
								showAction: false
							});
							this.$router.push("/empleados");
						} else {
							Snackbar.show({
								text: response.body.error,
								actionText: "Cerrar",
								pos: "top-right",
								showAction: false,
								backgroundColor: "#F44336",
								actionTextColor: "#FFF"
							});
						}
					},
					response => {
						Snackbar.show({
							text:
							"No se pudieron obtener los puestos de empleado. Recargue la página.",
							actionText: "Cerrar",
							pos: "top-right",
							showAction: false,
							backgroundColor: "#F44336",
							actionTextColor: "#FFF"
						});
					}
					);
			}
		},
		validarEmpleado() {
			!this.empleado.nombre_emn
			? (this.val.v_nombre = true)
			: (this.val.v_nombre = false);
			!this.empleado.ap_pat_emn
			? (this.val.v_ap_pat = true)
			: (this.val.v_ap_pat = false);
			!this.empleado.ap_mat_emn
			? (this.val.v_ap_mat = true)
			: (this.val.v_ap_mat = false);
			!this.empleado.fecha_nac_emn
			? (this.val.v_fecha_nac = true)
			: (this.val.v_fecha_nac = false);
			!this.empleado.sexo_emn
			? (this.val.v_sexo = true)
			: (this.val.v_sexo = false);
			!this.empleado.direccion_emn
			? (this.val.v_direccion = true)
			: (this.val.v_direccion = false);
			!this.empleado.num_ext_emn
			? (this.val.v_num_ext = true)
			: (this.val.v_num_ext = false);
			!this.empleado.colonia_emn
			? (this.val.v_colonia = true)
			: (this.val.v_colonia = false);
			!this.empleado.municipio_emn
			? (this.val.v_municipio = true)
			: (this.val.v_municipio = false);
			!this.empleado.estado_emn
			? (this.val.v_estado = true)
			: (this.val.v_estado = false);
			!this.empleado.tel_emn
			? (this.val.v_tel = true)
			: (this.val.v_tel = false);
			!this.empleado.curp_emn
			? (this.val.v_curp = true)
			: (this.val.v_curp = false);
			!this.empleado.nss_emn
			? (this.val.v_nss = true)
			: (this.val.v_nss = false);
			!this.empleado.persona_contacto_emn
			? (this.val.v_persona_contacto = true)
			: (this.val.v_persona_contacto = false);
			!this.empleado.tel_contacto_emn
			? (this.val.v_tel_contacto = true)
			: (this.val.v_tel_contacto = false);
			!this.empleado.direccion_contacto_emn
			? (this.val.v_direccion_contacto = true)
			: (this.val.v_direccion_contacto = false);
			if (
				this.val.v_nombre ||
				this.val.v_ap_pat ||
				this.val.v_ap_mat ||
				this.val.v_fecha_nac ||
				this.val.v_sexo ||
				this.val.v_direccion ||
				this.val.v_num_ext ||
				this.val.v_colonia ||
				this.val.v_municipio ||
				this.val.v_estado ||
				this.val.v_tel ||
				this.val.v_curp ||
				this.val.v_persona_contacto ||
				this.val.v_tel_contacto ||
				this.val.v_direccion_contacto
				) {
				Snackbar.show({
					text: "Por favor llene todos los campos marcados con *",
					actionText: "Cerrar",
					pos: "top-right",
					showAction: false,
					backgroundColor: "#F44336",
					actionTextColor: "#FFF"
				});
			return false;
		} else {
			return true;
		}
	}
},
beforeCreate() {
	if (!this.$session.exists()) {
		this.$router.push("/login");
	}
},
created() {
	this.obtenerEmpleado();
},
data() {
	return {
		empleado: {
			nombre_emn: null,
			ap_pat_emn: null,
			ap_mat_emn: null,
			sexo_emn: null,
			estado_civil_emn: null,
			fecha_nac_emn: null,
			direccion_emn: null,
			num_ext_emn: null,
			codigo_postal_emn: null,
			colonia_emn: null,
			estado_emn: null,
			municipio_emn: null,
			tel_emn: null,
			cel_emn: null,
			email_emn: null,
			escolaridad_emn: null,
			fecha_ing_emn: null,
			nss_emn: null,
			curp_emn: null,
			rfc_emn: null,
			peso_emn: null,
			estatura_emn: null,
			camisa_emn: null,
			pantalon_emn: null,
			calzado_emn: null,
			complexion_emn: null,
			ojos_emn: null,
			piel_emn: null,
			cabello_emn: null,
			tipo_sangre_emn: null,
			experiencia_emn: null,
			anos_exp_emn: null,
			nombre_conyuge_emn: null,
			tel_conyuge_emn: null,
			hijos_emn: null,
			dependientes_emn: null,
			persona_contacto_emn: null,
			tel_contacto_emn: null,
			direccion_contacto_emn: null,
			num_contacto_emn: null,
			colonia_contacto_emn: null,
			puesto_epn: null,
			observaciones_emn: null,
			cuenta_ban_emn: null,
        //plan de pago
        id_pln_eph: null
      },
      val: {
      	v_nombre: null,
      	v_ap_pat: null,
      	v_ap_mat: null,
      	v_sexo: null,
      	v_estado_civil: null,
      	v_fecha_nac: null,
      	v_direccion: null,
      	v_num_ext: null,
      	v_codigo_postal: null,
      	v_colonia: null,
      	v_estado: null,
      	v_municipio: null,
      	v_tel: null,
      	v_cel: null,
      	v_email: null,
      	v_escolaridad: null,
      	v_fecha_ing: null,
      	v_nss: null,
      	v_curp: null,
      	v_rfc: null,
      	v_peso: null,
      	v_estatura: null,
      	v_camisa: null,
      	v_pantalon: null,
      	v_calzado: null,
      	v_complexion: null,
      	v_ojos: null,
      	v_piel: null,
      	v_cabello: null,
      	v_tipo_sangre: null,
      	v_experiencia: null,
      	v_anos_exp: null,
      	v_nombre_conyuge: null,
      	v_tel_conyuge: null,
      	v_hijos: null,
      	v_dependientes: null,
      	v_persona_contacto: null,
      	v_tel_contacto: null,
      	v_direccion_contacto: null,
      	v_num_contacto: null,
      	v_colonia_contacto: null,
      	v_puesto: null,
      	v_observaciones: null,
      	v_cuenta_ban: null,
        //plan de pago
        v_id_pln: null,
        //validaciones de conceptos
        v_con_id: null,
        v_con_desc: null,
        v_con_importe: null,
        v_con_quincenas: null,
        v_con_importe_qnal: null
      },
      con_add: {
      	id: null,
      	desc: null,
      	importe: 0,
      	quincenas: 1,
      	importe_qnal: 0
      },
      conceptosNomina: [],
      conceptosListado: [],
      puestosListado: [],
      planesListado: []
    };
  }
};
</script>


// WEBPACK FOOTER //
// EmpleadosEditar.vue?0a98f1b4